import { Link } from 'react-router-dom';

export default function ArticleEntry() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
          <div className="lg:w-1/2 w-full">
            <div className="relative rounded-2xl overflow-hidden" style={{ height: '380px' }}>
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20logistics%20and%20shopping%20concept%20photography%2C%20warm%20beige%20background%2C%20clean%20editorial%20style%2C%20soft%20natural%20lighting%2C%20modern%20ecommerce%20aesthetic%2C%20elegant%20product%20arrangement%20with%20gentle%20shadows&width=800&height=600&seq=article-entry-image&orientation=landscape"
                alt="YOYBUY Spreadsheet руководство"
                className="w-full h-full object-cover rounded-2xl"
              />
              <div className="absolute top-4 left-4 flex flex-wrap gap-2">
                {['SEO Guide 2026', 'China Agent', 'Spreadsheet'].map((tag) => (
                  <span key={tag} className="px-3 py-1.5 rounded-lg bg-white/20 backdrop-blur-md text-white text-xs font-medium whitespace-nowrap">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>

          <div className="lg:w-1/2 w-full flex flex-col gap-6">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight">
              YOYBUY Spreadsheet:
              <br />
              Полное руководство 2026
            </h2>
            <p className="text-foreground-600 text-base leading-relaxed">
              Узнайте всё о системе закупок через YOYBUY Spreadsheet: как она работает, чем отличается от Kakobuy и Superbuy, как сэкономить на комиссиях и организовать эффективный процесс покупок из Китая. Пошаговое руководство для начинающих и опытных пользователей.
            </p>

            <div className="bg-foreground-950 rounded-2xl p-6 flex flex-col md:flex-row items-start md:items-center gap-4">
              <div className="flex-1">
                <span className="inline-block px-3 py-1 rounded-lg bg-accent-500/20 text-accent-400 text-xs font-medium mb-2 whitespace-nowrap">
                  SEO Guide
                </span>
                <p className="text-white/80 text-sm leading-relaxed">
                  Полный разбор YOYBUY Spreadsheet: интерфейс, тарифы, сравнение с конкурентами, лайфхаки и лучшие практики
                </p>
              </div>
              <Link
                to="/blog/yoybuy-spreadsheet-polnoe-rukovodstvo"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-white/30 text-white font-medium text-sm hover:bg-white/10 transition-all duration-200 whitespace-nowrap flex-shrink-0 cursor-pointer"
              >
                Читать статью
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="flex flex-wrap gap-3">
              <Link to="/" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors whitespace-nowrap">
                ← Главная
              </Link>
              <a href="#compare" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors whitespace-nowrap">
                Сравнение платформ
              </a>
              <a href="#categories" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors whitespace-nowrap">
                Категории товаров
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}